var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"model":_vm.form}},[_c('LicenseRenderer',{attrs:{"licenseName":"submission","form":{
      mediaRightsPerFilm: {
        value: _vm.form.rights_media,
        disabled: !_vm.getEditability(_vm.value.rights_media),
      },
      thirdParty: {
        value: _vm.form.rights_general,
        disabled: !_vm.getEditability(_vm.value.rights_general),

      },
      monetisation: {
        value: _vm.form.rights_third_party_and_monetization,
        disabled: !_vm.getEditability(_vm.value.rights_third_party_and_monetization),
      },
      labs: {
        value: _vm.form.rights_labs,
        disabled: !_vm.getEditability(_vm.value.rights_labs), 
      },  
      additionalAgreementsForm: {
        value: _vm.form.additional_agreements,
      },
    }},on:{"input":_vm.updateCheckBox}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-436642fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submission/steps/Terms.vue
// module id = 703
// module chunks = 0 1